<template>
  <div>
    <b-modal
      id="modal-cadastrar"
      @show="Iniciar"
      centered
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      title="Cadastro"
    >
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group
            id="strnome-grupo"
            label="Nome Completo"
            label-for="strnome"
          >
            <b-form-input
              id="strnome"
              ref="strnome"
              autocomplete="off"
              v-model.trim="cadastro.strnome"
              type="text"
              placeholder="Seu Nome Completo"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group
            id="strnome_social-grupo"
            label="Nome Social (Se possuir)"
            label-for="strnome_social"
          >
            <b-form-input
              id="strnome_social"
              ref="strnome_social"
              v-model.trim="cadastro.strnome_social"
              type="text"
              placeholder="Seu Nome Social"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group id="stremail-grupo" label="E-mail" label-for="stremail">
            <b-form-input
              id="stremail"
              ref="stremail"
              v-model.trim="cadastro.stremail"
              type="email"
              placeholder="Seu e-mail"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group id="strcpf-grupo" label="CPF" label-for="strcpf">
            <b-form-input
              id="strcpf"
              ref="strcpf"
              v-model.trim="cadastro.strcpf"
              type="tel"
              placeholder="Seu CPF"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group id="strsenha-grupo" label="Senha" label-for="strsenha">
            <b-form-input
              id="strsenha"
              ref="strsenha"
              v-model.trim="cadastro.strsenha"
              type="password"
              placeholder="Sua senha"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-form-group
            id="strsenha_confirmation-grupo"
            label="Confirmação de Senha"
            label-for="senha"
          >
            <b-form-input
              v-on:keyup.enter="Cadastrar"
              id="strsenha_confirmation"
              ref="strsenha_confirmation"
              v-model.trim="cadastro.strsenha_confirmation"
              type="password"
              placeholder="Sua confirmação de senha"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{}">
        <b-button size="sm" variant="success" @click="Cadastrar()"
          ><b-icon-check-circle-fill class="mr-2" /> Cadastrar</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      api: this.$parent.api,
      cadastro: {
        strnome: null,
        strnome_social: null,
        stremail: null,
        strcpf: null,
        strsenha: null,
        strsenha_confirmation: null,
      },
      Toast: this.$swal.mixin({
        toast: true,
        position: "top-end",
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: false,
      }),
    };
  },
  methods: {
    alertaSucesso(mensagem) {
      this.$swal("Confirmação", mensagem, "success");
    },
    alertaErro(mensagem) {
      this.Toast.fire(mensagem, "", "error");
    },
    Cadastrar() {
      if (
        !this.cadastro.strnome ||
        (this.cadastro.strnome && this.cadastro.strnome.length <= 0)
      ) {
        this.alertaErro(
          "Preencha o campo " +
            this.$refs.strnome.$parent.$el.firstChild.innerText
        );
        this.$refs.strnome.focus();
        return;
      }
      if (
        !this.cadastro.stremail ||
        (this.cadastro.stremail && this.cadastro.stremail.length <= 0)
      ) {
        this.alertaErro(
          "Preencha o campo " +
            this.$refs.stremail.$parent.$el.firstChild.innerText
        );
        this.$refs.stremail.focus();
        return;
      }
      if (
        !this.cadastro.strcpf ||
        (this.cadastro.strcpf && this.cadastro.strcpf.length <= 0)
      ) {
        this.alertaErro(
          "Preencha o campo " +
            this.$refs.strcpf.$parent.$el.firstChild.innerText
        );
        this.$refs.strcpf.focus();
        return;
      }
      if (
        !this.cadastro.strsenha ||
        (this.cadastro.strsenha && this.cadastro.strsenha.length <= 0)
      ) {
        this.alertaErro(
          "Preencha o campo " +
            this.$refs.strsenha.$parent.$el.firstChild.innerText
        );
        this.$refs.strsenha.focus();
        return;
      }
      if (
        !this.cadastro.strsenha_confirmation ||
        (this.cadastro.strsenha_confirmation &&
          this.cadastro.strsenha_confirmation.length <= 0)
      ) {
        this.alertaErro(
          "Preencha o campo " +
            this.$refs.strsenha_confirmation.$parent.$el.firstChild.innerText
        );
        this.$refs.strsenha_confirmation.focus();
        return;
      }

      if (this.cadastro.strsenha_confirmation !== this.cadastro.strsenha) {
        this.alertaErro("A senhas não conferem!");
        this.$refs.strsenha_confirmation.focus();
        return;
      }

      this.axios
        .post(this.api + "usuario", this.cadastro)
        .then((response) => {
          //se cadastrou
          if (response.data) {
            this.alertaSucesso(response.data.mensagem);
            this.$bvModal.hide("modal-cadastrar");
          }
        })
        .catch((error) => {
          if (error.response) this.alertaErro(error.response.data.erro);
          else this.alertaErro("Ocorreu um erro inesperado, tente novamente!");
        });
    },
    Iniciar() {
      this.cadastro = {
        strnome: null,
        strnome_social: null,
        stremail: null,
        strcpf: null,
        strsenha: null,
        strsenha_confirmation: null,
      };
    },
  },
};
</script>
<style>
#modal-cadastrar .modal-header {
  background-color: #065f46 !important;
  color: white !important;
}
#modal-cadastrar .modal-footer {
  justify-content: flex-start !important;
  background-color: #ececec !important;
}
</style>